import AdvancedSearchFooter from './advanced-search-footer';
export default AdvancedSearchFooter;